<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.syllabus'),
                        href: null,
                    },
                    {
                        name: $tc('messages.syllabus_contents', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex justify-end space-x-2">
            <AppButton element="InertiaLink" :href="route('dimensions.index')">
                {{ $tc('messages.dimensions', 2) }}
            </AppButton>
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-4">
                    <label class="block text-sm font-medium leading-5 text-gray-700">{{ $t('messages.search') }}</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.search"
                            type="text"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>

                <div class="sm:col-span-3">
                    <FormLabel :value="$t('messages.grade_level')" for="grade_level_ids" />
                    <div class="mt-1">
                        <label v-for="grade_level in options.gradeLevels" class="mr-1">
                            <input
                                v-model="form.grade_level_ids"
                                name="stages"
                                :value="grade_level.value"
                                type="checkbox"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            {{ grade_level.text }}
                        </label>
                    </div>
                    <FormError :value="form.errors.grade_level_ids" class="mt-2" />
                </div>

                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.categories', 1)" for="category_id" />
                        <FormSelect
                            id="category_id"
                            v-model="form.category_id"
                            :options="options.categories"
                            property-name="text"
                            optgroups
                            class="mt-1"
                        />
                        <FormError :value="form.errors.category_id" class="mt-2" />
                    </div>
                </div>
            </div>
        </form>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.title') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.categories', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.grade_level', 2) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(syllabus_content, index) in syllabus_contents.data"
                            >
                                <td class="max-w-sm px-6 py-4 text-sm leading-5 text-gray-500">
                                    {{ syllabus_content.title }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ syllabus_content.category_name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ syllabus_content.grade_level_names }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <!--                                <inertia-square-link-button action="show" :href="syllabus_content.links.show"></inertia-square-link-button>-->
                                    <InertiaSquareLinkButton action="edit" :href="syllabus_content.links.edit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="syllabus_contents" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import InertiaLinkButton from '@/components/InertiaLinkButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import AppButton from '../../../components/AppButton.vue';

export default {
    components: {
        AppButton,
        SubmitFormButton,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        FormLabel,
        FormError,
        FormSelect,
        InertiaLinkButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'syllabus_contents', 'filters', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
                grade_level_ids: this.filters.grade_level_ids,
                category_id: this.filters.category_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
